import { useState, useRef } from 'react';

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt')?.toString().trim() || '';
    if (honeypot) {
      setStatus('success');
      return;
    }

    setStatus('idle');
    setErrorMsg('');

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        params.append(key, value.toString());
      }
    });

    try {
      const res = await fetch('https://readdy.ai/api/form/d9u06378l97n3eas3epg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch {}

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        if (msg.toLowerCase().includes('spam')) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后再试');
        } else {
          setStatus('error');
          setErrorMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto mb-5">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-100 mb-3">
          订阅我们的资讯
        </h2>
        <p className="text-foreground-400 text-sm md:text-base mb-8 max-w-md mx-auto">
          第一时间获取最新的自拍技巧、滤镜推荐和设备评测，让你的自拍永远在线。
        </p>
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form="true"
          id="newsletter-form"
        >
          <input
            type="email"
            name="email"
            placeholder="输入你的邮箱地址"
            className="flex-1 px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-300 transition-colors"
            required
          />
          <button
            type="submit"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            订阅
          </button>
          <div className="honeypot-wrapper">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
        </form>
        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-500">订阅成功！感谢你的关注。</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}